export const MARKET_WIDE_BADGE_TOOLTIP =
  'This section shows market-wide data. Your filters are not applied here.';

export const VERIFIED_LOCK_BADGE_TOOLTIP =
  'This data is available only for verified markets (blue checkmark in search). It is not available for submarkets or custom markets.';

export const BADGE_PILL_SX = {
  display: 'inline-flex' as const,
  alignItems: 'center',
  gap: 0.375,
  px: 1.25,
  py: 0.375,
  borderRadius: 10,
  fontSize: '0.75rem',
  fontWeight: 600,
  cursor: 'help' as const,
} as const;
